import { Stack, Typography, useTheme } from '@mui/material';

// Components
import { BookmarkTypes, IBookmarkTradeData } from 'src/model/bookmark';
import IconFeather from 'src/components/common/Icon';
import { Calendar, ChevronsRight } from 'react-feather';
import { FORMAT_DATE_TIME } from 'src/utils/constants/config';
import FlagCountry from 'src/components/common/FlagCountry';
import { renderTextOrDefault } from 'src/utils/helpers/stringHelpers';
import dayjs from 'dayjs';
import TooltipFormLabel from 'src/components/common/TooltipFormLabel';
import BookmarkCardLayout from 'src/features/Bookmark/Common/BookmarkCardLayout';
import { isEmpty, pick } from 'lodash';
import { useNavigate } from 'react-router-dom';
import { AuthRouteKeys } from 'src/utils/constants/routes';
import { handleQueryParamFromObject } from 'src/utils/helpers/queryParam';
import { TradeDataSearchBy } from 'src/features/TradeData/Common/FormSearchGlobalTrade';

interface ITradeDataBookmarkProps {
  dataBookmark: IBookmarkTradeData;
}

interface ICountryFromToProps {
  codeFrom: string;
  codeTo: string;
  nameFrom: string;
  nameTo: string;
}

const CountryFromTo = (props: ICountryFromToProps) => {
  const { codeFrom, codeTo, nameFrom, nameTo } = props;
  const theme = useTheme();

  return (
    <Stack spacing={1} direction="row" alignItems="center">
      <FlagCountry code={codeFrom || ''} colorDefaultFlag={theme.palette.text.secondary} />
      <Typography color={'text.secondary'} variant="caption" align="left">
        {renderTextOrDefault(nameFrom)}
      </Typography>
      <IconFeather icon={<ChevronsRight />} muiProps={{ sx: { color: theme.palette.text.secondary, fontSize: 16 } }} />
      <FlagCountry code={codeTo || ''} colorDefaultFlag={theme.palette.text.secondary} />
      <Typography color={'text.secondary'} variant="caption" align="left">
        {renderTextOrDefault(nameTo)}
      </Typography>
    </Stack>
  );
};

const TradeBookmarkCard = ({ dataBookmark }: ITradeDataBookmarkProps) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const handleClickBookmark = () => {
    const searchString = handleQueryParamFromObject({
      ...pick(dataBookmark, [
        'hs_code',
        'start_date',
        'end_date',
        'imp_country_code',
        'exp_country_code',
        'exp_port_code',
        'imp_port_code',
      ]),
      _search_by: TradeDataSearchBy.HS_CODE,
    });
    navigate({ pathname: AuthRouteKeys.TradeData, search: searchString });
  };

  return (
    <BookmarkCardLayout data={dataBookmark} bookmarkType={BookmarkTypes.TradeData}>
      <Stack spacing={1} direction="column" onClick={handleClickBookmark}>
        <Typography color={theme.palette.primary.main} variant="subtitle1">
          {`${dataBookmark.hs_code} -- ${dataBookmark.hs_code_description}`}
        </Typography>
        <Stack spacing={3} direction="row" alignItems="center">
          {(!isEmpty(dataBookmark.exp_country_code) || !isEmpty(dataBookmark.imp_country_code)) && (
            <CountryFromTo
              codeFrom={dataBookmark.exp_country_code}
              codeTo={dataBookmark.imp_country_code}
              nameFrom={dataBookmark.exp_country_code}
              nameTo={dataBookmark.imp_country_code}
            />
          )}
          <Stack spacing={1} direction="row" alignItems="center">
            <IconFeather
              icon={<Calendar />}
              muiProps={{
                fontSize: 'small',
                sx: {
                  color: theme.palette.text.secondary,
                },
              }}
            />
            <Typography variant="caption" align="left" color="text.secondary">
              {dayjs(dataBookmark?.start_date?.toString(), FORMAT_DATE_TIME.yyyy_mm_dd).format(
                FORMAT_DATE_TIME.FULL_ONLY_DATE,
              )}
            </Typography>
            <Typography variant="caption" align="left" color="text.secondary">
              -
            </Typography>
            <Typography variant="caption" align="left" color="text.secondary">
              {dayjs(dataBookmark?.end_date?.toString(), FORMAT_DATE_TIME.yyyy_mm_dd).format(
                FORMAT_DATE_TIME.FULL_ONLY_DATE,
              )}
            </Typography>
            <TooltipFormLabel sxIcon={{ color: 'white' }} title={'Arrival Date'} />
          </Stack>
        </Stack>
        {/*<CountryFromTo*/}
        {/*  codeFrom={data.exp_country_code}*/}
        {/*  codeTo={data.imp_country_code}*/}
        {/*  nameTo={data.supplier_name}*/}
        {/*  nameFrom={data.buyer_name}*/}
        {/*/>*/}
        {/*<CountryFromTo*/}
        {/*  codeFrom={data.exp_country_code}*/}
        {/*  codeTo={data.imp_country_code}*/}
        {/*  nameTo={data.exp_port_name}*/}
        {/*  nameFrom={data.imp_port_name}*/}
        {/*/>*/}
      </Stack>
    </BookmarkCardLayout>
  );
};
export default TradeBookmarkCard;
